import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { LogOut, Box, LayoutDashboard, Award, BookOpen, Video } from 'lucide-react';

export const Navigation = () => {
    const { logout } = useAuth();
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const navItems = [
        { id: 'model', label: 'Model', icon: <Box className="w-4 h-4" />, action: () => window.scrollTo({ top: 0, behavior: 'smooth' }) },
        { id: 'thesis-overview', label: 'Overview', icon: <LayoutDashboard className="w-4 h-4" />, action: () => scrollToSection('thesis-overview') },
        { id: 'contributions', label: 'Contributions', icon: <Award className="w-4 h-4" />, action: () => scrollToSection('contributions') },
        { id: 'chapters', label: 'Chapters', icon: <BookOpen className="w-4 h-4" />, action: () => scrollToSection('chapters') },
        { id: 'video-overview', label: 'Video', icon: <Video className="w-4 h-4" />, action: () => scrollToSection('video-overview') },
    ];

    return (
        <nav className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-50 bg-white/80 backdrop-blur-md px-4 py-3 rounded-full shadow-lg border border-white/50 flex items-center gap-4 md:gap-6 w-[90%] max-w-fit justify-between md:justify-center overflow-x-auto no-scrollbar">
            {navItems.map((item) => (
                <button
                    key={item.id}
                    onClick={item.action}
                    className="text-sm font-bold text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-2 whitespace-nowrap"
                    title={item.label}
                >
                    {item.icon}
                    <span className="hidden md:inline">{item.label}</span>
                </button>
            ))}

            <div className="w-px h-6 bg-gray-300 my-auto flex-shrink-0"></div>

            <button
                onClick={logout}
                className="text-sm font-bold text-red-500 hover:text-red-600 transition-colors flex items-center gap-2 whitespace-nowrap"
                title="Sign Out"
            >
                <LogOut className="w-4 h-4" />
                <span className="hidden md:inline">Sign Out</span>
            </button>
        </nav>
    );
};
